import React from "react";
import { CheckList } from "./CheckList";
import { images, visualChecks } from "../data/content";
export function VisualPlans() {
  return <section className="bg-peach px-4 py-16" aria-labelledby="visual-title" data-id="element-304" data-mp="108r8wnh9iex7">
      <div className="mx-auto grid max-w-5xl items-center gap-10 md:grid-cols-2" data-id="element-305" data-mp="vbshicozgm2p">
        <img src={images.blueprint} alt="Plan pages with technical views and cut list" className="w-full rounded-lg shadow-sm" data-id="element-306" data-mp="ra6xm7e177j0" />
        <div data-id="element-307" data-mp="1nz4t5rtlv9h8">
          <h2 id="visual-title" className="font-heading text-2xl font-bold uppercase leading-tight md:text-3xl" data-id="element-308" data-mp="1nxk94w4x38xm">
            See exactly <span className="text-brand" data-id="element-309" data-mp="1eyylimkl93pz">what you're building</span>
          </h2>
          <p className="mt-4 text-sm font-medium" data-id="element-310" data-mp="1f0t59xk4ipsh">Why start cutting before you understand the final project?</p>
          <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-311" data-mp="3jtfp9p5up25">
            Every plan is designed to help you visualize the build before assembly begins. Depending on the project, you'll see:
          </p>
          <div className="mt-5" data-id="element-312" data-mp="m7h1ccdr6u17">
            <CheckList items={visualChecks} columns={2} data-id="element-313" data-mp="m8imxaseayx6" />
          </div>
          <p className="mt-6 text-sm leading-relaxed text-ink-muted" data-id="element-314" data-mp="r6tv7h31l1da">
            So you can understand not only what the project looks like, but <strong className="text-ink" data-id="element-315" data-mp="d60yqqt6jw7j">how it actually goes together.</strong>
          </p>
        </div>
      </div>
    </section>;
}